document.addEventListener('DOMContentLoaded', () => {
  const initCartDrawerPreorderStatus = () => {
    const cartDrawer = document.getElementById('cart-drawer');
    if (!cartDrawer) return;

    const banner = cartDrawer.querySelector('[data-cart-preorder-banner]');
    if (!banner) return;

    const titleElement = banner.querySelector('[data-cart-preorder-title]');
    const items = cartDrawer.querySelectorAll('line-item');
    
    let preorderCount = 0;
    let totalCount = items.length;

    if (totalCount === 0) {
      banner.hidden = true;
      return;
    }

    items.forEach(item => {
      // Check for the script tag containing preorder data
      const preorderDataScript = item.querySelector('.line-item-preorder-data');
      if (preorderDataScript) {
        preorderCount++;
      }
    });

    if (preorderCount > 0) {
      banner.hidden = false;
      if (preorderCount === totalCount) {
        // All items are pre-order
        if (titleElement) {
            titleElement.textContent = banner.getAttribute('data-preorder-title-default');
        }
      } else {
        // Mixed order (some pre-order, some in-stock)
        if (titleElement) {
            titleElement.textContent = banner.getAttribute('data-preorder-title-mixed');
        }
      }
    } else {
      // No pre-order items
      banner.hidden = true;
    }
  };

  // Run on load
  initCartDrawerPreorderStatus();

  // Run on cart updates
  document.addEventListener('cart:change', () => {
    // Small delay to ensure DOM is updated
    setTimeout(initCartDrawerPreorderStatus, 100);
  });
  
  // Run on section load (in theme editor)
  document.addEventListener('shopify:section:load', (event) => {
    if (event.target.id === 'cart-drawer' || event.target.querySelector('#cart-drawer')) {
      initCartDrawerPreorderStatus();
    }
  });
});
